import useAjax from '@/hooks/useAjax.tsx';

export const useFetcher = () => {
  const [fetcher] = useAjax({
    type: 'GET',
  });
  const fetchData = async <T = unknown>(url: string): Promise<T> => {
    return fetcher({
      url,
    });
  };

  return fetchData;
};
